<template>
  <div id="app">
    <router-view class="d-flex flex-column full-height"/>
    <notifications group="default" />
    <notifications group="callCenterInfo" position="bottom left" />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Open+Sans');
  html {
    font-size: 15px;
  }
  html, #app, body  {
    height: 100vh;
    font-family: 'Open Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  .full-height {
    height: 100vh;
  }
  .datepicker.form-control {
      background-color: #fff;
  }
  .body {
    margin-top: 10px;
    margin-bottom: 10px;
    flex-grow: 1;
  }
  .card-header-tabs {
      outline: none;
  }
  tr.order-prods td {
    vertical-align: middle;
  }
  .scroll-y {
    overflow-y: scroll;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .nav-tabs .nav-link.active {
    font-weight: bold;
  }
  .no-outline {
    outline: none!important;
  }
  .fullSizeModal > .modal-dialog {
    max-width:1800px;
  }
  .el-input__inner {
    height:36px;
    line-height:36px;
  }
  .pos-rel {
    position:relative;
  }
  .el-date-editor.el-input {
    width: inherit;
  }
  .flex-grow-2 {
    flex-grow: 2;
  }
  .icon-col {
    width:62px;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-y-scroll {
    overflow-y: scroll;
  }
  div.dropdown-toggle::after {
    display:none;
  }
  .vb .dropdown-toggle {
    padding:0;
  }
  .vb .dropdown-toggle input {
    border: none;
    margin:0;
  }
  .flex-basis-0 {
    flex-basis: 0px;
  }
  .s {
    color: silver;
  }
  .button-brunch {
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    padding: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue